import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormObserverService } from '../../../services/form-observer.service';
import { FormioCustomComponent } from 'angular-formio';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe-decorator';

@Component({
  selector: 'app-product-field',
  templateUrl: './product-field.component.html',
  styleUrls: ['./product-field.component.scss'],
})
export class ProductFieldComponent
  implements FormioCustomComponent<object>, OnInit
{
  disabled: boolean;
  @Input() value: object;
  @Output() valueChange = new EventEmitter<object>();
  @Input() myLabel: string;
  @Input() name: string;

  productlist: any = [];
  selectedproductlist: any = [];
  selectedProductNames: any[];
  selectedProducts: any[];
  locationNames: string;
  productNames: string;
  ProductIds: any[];
  products: any[];
  productCount: number;
  totalselectedproduct: number;
  grandtotal: number;
  productFieldLabel: string = '';

  @AutoUnsubscribe()
  private castproductlists$: Subscription;
  @AutoUnsubscribe()
  private castselectedproductlists$: Subscription;
  @AutoUnsubscribe()
  private casttotalselectedproduct$: Subscription;

  constructor(private productFieldObserverService: FormObserverService) {
    this.selectedProducts = [];
    this.selectedProductNames = [];
    this.productNames = '';
    this.productlist = [];
    this.selectedproductlist = [];
    this.totalselectedproduct = 0;
    this.grandtotal = 0;
  }

  ngOnInit() {
    this.name = this.name.replace('data[', '').replace(']', '');

    this.castproductlists$ =
      this.productFieldObserverService.castproductlists.subscribe(
        (productlist) => {
          // this.productlist = productlist;
        }
      );

    this.castselectedproductlists$ =
      this.productFieldObserverService.castselectedproductlists.subscribe(
        (selectedproductlist) => {
          this.selectedproductlist = selectedproductlist;
        }
      );

    this.casttotalselectedproduct$ =
      this.productFieldObserverService.casttotalselectedproduct.subscribe(
        (totalselectedproduct) => {
          this.totalselectedproduct = totalselectedproduct;
        }
      );

    // let productList = this.productFieldObserverService.castProperty('productfield', 'data.values', this.name);
    let component = this.productFieldObserverService.searchComponent(
      'productfield',
      this.name
    );
    this.productlist = component.data && component.data.values;
    this.productFieldLabel = component.data && component.data.label;

    this.productFieldObserverService.updateProductLists(this.productlist);
    this.productFieldObserverService.updateProductFieldLabel(
      this.productFieldLabel
    );
  }

  updateValue(payload: object) {
    this.value = payload; // Should be updated first
    this.valueChange.emit(payload); // Should be called after this.value update
  }

  toggleProduct(e: any, product: any) {
    let checkbox = e.target;
    product.newkey =
      product.key + ' - $' + parseFloat(product.price).toFixed(2);

    if (checkbox.checked) {
      this.selectedProducts.push({
        value: product.value,
        key: product.key,
        price: product.price,
      });
      this.selectedProductNames.push(product.newkey);
      this.grandtotal += parseFloat(product.price);
    } else {
      this.selectedProducts = this.selectedProducts.filter((item) => {
        return item.key !== product.key;
      });

      this.selectedProductNames = this.selectedProductNames.filter((item) => {
        return item !== product.newkey;
      });

      this.grandtotal -= parseFloat(product.price);
    }

    this.constructproductNames(this.selectedProductNames);
    this.updateValue({
      label: this.productFieldLabel,
      amount: this.grandtotal,
      selectedProducts: this.selectedProducts,
    });
  }

  constructproductNames(selectedProductNames?: any) {
    let hasPreviousSelection = this.ProductIds && this.ProductIds.length > 0;
    let selectedProducts = hasPreviousSelection
      ? this.products
          .filter((item) => {
            return this.ProductIds.some((product) => {
              return product === item.key;
            });
          })
          .map((result) => {
            return result.key;
          })
      : [];

    if (selectedProductNames && selectedProductNames.length > 0) {
      selectedProducts = selectedProductNames;
    }

    // this.productNames =
    //   selectedProducts.length > 2
    //     ? selectedProducts.slice(0, 2).join(', ') + ' + '
    //     : selectedProducts.join(', ');

    this.productNames =
      selectedProducts.length < 1
        ? selectedProducts.slice(0, 2).join('\r\n') + ' + '
        : selectedProducts.join('\r\n');
    this.productNames = selectedProducts.length === 0 ? '' : this.productNames; // clear if length is zero

    this.productCount = selectedProducts.length;
  }
}
